import type { ReactNode } from 'react'
import type { AuthPageMarketing } from '@/components/Auth/authMarketing'
import { ConnectedSystemsFlow } from './ConnectedSystemsFlow'
import { IntegrationLogoStrip } from './IntegrationLogoStrip'

interface AuthExperienceProps {
  marketing: AuthPageMarketing
  children: ReactNode
}

export function AuthExperience({ marketing, children }: AuthExperienceProps) {
  return (
    <div className="pp-auth">
      <aside className="pp-auth__story">
        <div className="pp-auth__story-inner">
          <p className="pp-kicker pp-kicker--light">{marketing.panelKicker}</p>
          <h1>{marketing.panelTitleLine1}<span>{marketing.panelTitleEmphasis}</span></h1>
          <IntegrationLogoStrip className="pp-auth__integration-logos" onDark />
          <p className="pp-auth__lead">{marketing.panelSubheadline}</p>
          <ConnectedSystemsFlow compact />
          <div className="pp-auth__features">
            {marketing.features.map((feature, index) => (
              <article key={feature.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <div><h2>{feature.title}</h2><p>{feature.description}</p></div>
              </article>
            ))}
          </div>
        </div>
      </aside>
      <section className="pp-auth__form-side">
        <div className="pp-auth__form-wrap">{children}</div>
      </section>
    </div>
  )
}

export default AuthExperience
